import axios from "axios";
import { Base_URL } from "../url";

export const saveGLDetails = async (glData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/GeneralLedger/GeneralLedgerMaster?UserName=${username}`,
      glData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving GL details!";
  }
};

export const getAllGeneralLedgers = async () => {
  try {
    const response = await axios.get(`${Base_URL}/GeneralLedger/GetAllGeneralLedgers`);
    return response.data; // or format the response as needed
  } catch (error) {
    throw error.response?.data || "Error fetching general ledgers!";
  }
};

export const getAllBanks = async () => {
  try {
    const response = await axios.get(`${Base_URL}/BankMaster/GetAllBanks`);
    return response.data.map(bank => ({
      code: bank.code,
      description: bank.description
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching banks!";
  }
};